export const data_fr_theme = "data-fr-theme";
export const data_fr_scheme = "data-fr-scheme";

export const rootColorSchemeStyleTagId = "dsfr-root-color-scheme";
